import React from "react";
import Masonry from "react-masonry-css";
import Card from "./../Card";
import { CardHolderDiv, SearchFieldBox } from "./elements";

const useSearch = true;

const cardSort = (cards) =>
  cards.sort((x, y) => {
    // const digitPattern = /\d+/g;
    // const letterPattern = /[a-z]+/g;
    // const getLetters = (x) => {
    //   const result = String(x).toLowerCase().match(letterPattern);
    //   return result.length ? result[0] : "";
    // };
    // const getNumbers = (x) => {
    //   if (x) {
    //     const result = x.match(digitPattern);
    //     return result.length ? Number(result[0]) : null;
    //   }
    //   return null;
    // };
    // const xLetters = getLetters(x.data.LinkImageNumber);
    // const yLetters = getLetters(y.data.LinkImageNumber);
    // const xNumbers = getNumbers(x.data.LinkImageNumber);
    // const yNumbers = getNumbers(y.data.LinkImageNumber);

    // if (xLetters > yLetters) {
    //   return 1;
    // }
    // if (xLetters < yLetters) {
    //   return -1;
    // }
    // if (xLetters === yLetters) {
    //   if (xNumbers > yNumbers) {
    //     return 1;
    //   }
    //   if (xNumbers < yNumbers) {
    //     return -1;
    //   }
    //   return 0;
    // }
    // return 0;
    if (x.data.Annum > y.data.Annum) {
      return 1;
    }
    if (x.data.Annum < y.data.Annum) {
      return -1;
    }
    return 0;
  });

const searchThisCorpus = (inDataset, inSearchCorpus, searchFor) => {
  const searchTerms = searchFor
    .toLowerCase()
    .split(" ")
    .filter((x) => x !== "");
  return inDataset.filter((x, index) => {
    let found = false;
    for (let i = 0; i < searchTerms.length; i++) {
      if (inSearchCorpus[index].indexOf(searchTerms[i]) > -1) {
        found = true;
      }
    }
    return found;
  });
};

const CardHolder = ({ cards, noFilter }) => {
  const sortedCards = cardSort(cards);
  const [searchFor, setSearchFor] = React.useState("");
  const [oldSearchFor, setOldSearchFor] = React.useState(999);
  // console.log(sortedCards.map((x) => x.data.Annum));
  const sortedCorpus = sortedCards
    .map((x) => x.data)
    .map((x) =>
      `${x.Caption_for_Website} ${
        x.Notes_for_Website ? x.Notes_for_Website : ""
      } ${
        x.Section && x.Section.length ? x.Section.join(" ") : ""
      }`.toLowerCase()
    );

  const [searchedCards, setSearchedCards] = React.useState(sortedCards);

  React.useEffect(() => {
    if (searchFor.length && searchFor !== oldSearchFor) {
      setSearchedCards(searchThisCorpus(sortedCards, sortedCorpus, searchFor));
      setOldSearchFor(searchFor);
    }
  }, [searchFor, sortedCorpus, sortedCards, oldSearchFor]);

  // width: 40px + cardSize (250) * cards + gapSize(25) * (cards - 1)
  return (
    <CardHolderDiv>
      {useSearch && !noFilter ? (
        <SearchFieldBox>
          <label htmlFor="searchfield">
            Filter:{" "}
            <input
              type="text"
              id="searchfield"
              onChange={(e) => {
                if (e.target.value && e.target.value.length > 1) {
                  // console.log("searching for: ", e.target.value);
                  setSearchFor(e.target.value.toLowerCase());
                } else {
                  if (!e.target.value) {
                    // console.log("nothing in window!");
                    setSearchedCards(sortedCards);
                  }
                }
              }}
            />
          </label>
        </SearchFieldBox>
      ) : null}
      {searchedCards.length ? (
        <Masonry
          breakpointCols={{
            2214: 7,
            1939: 6,
            1664: 5,
            1389: 4,
            1114: 3,
            839: 2,
            564: 1,
          }}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {searchedCards.map((card, index) => (
            <Card key={index} index={index} id={card.id} cardData={card.data} />
          ))}
        </Masonry>
      ) : (
        <p>Nothing found! Try searching for something else?</p>
      )}
    </CardHolderDiv>
  );
};

export default CardHolder;
